import {
  UPDATE_CONFIG,
  UPDATE_LINEITEM,
  UPDATE_ISCOPY,
  UPDATE_ADD_TO_BUNDLE_DISABLED,
} from '../actions/actionTypes';

// never changes; we're just storing this in redux to help keep actions/connectors pure
export default (state = { isAddtoBundleDisabled: false }, action) => {
  switch (action.type) {
    case UPDATE_CONFIG: {
      const { configurationId } = action;

      return {
        ...state,
        configurationId,
      };
    }
    case UPDATE_LINEITEM: {
      const { lineItemId } = action;

      return {
        ...state,
        lineItemId,
      };
    }
    case UPDATE_ISCOPY: {
      const { isCopy } = action;

      return {
        ...state,
        isCopy,
      };
    }

    case UPDATE_ADD_TO_BUNDLE_DISABLED:
      return {
        ...state,
        isAddtoBundleDisabled: action.payload.isAddtoBundleDisabled,
      };

    default:
      return state;
  }
};
